import { render, staticRenderFns } from "./ClassRoom.vue?vue&type=template&id=d032786e&"
import script from "./ClassRoom.vue?vue&type=script&lang=js&"
export * from "./ClassRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports